<template>
	<div class="app-wrapper">
		<p class="title1">上海财经大学浙江学院</p>
		<p class="title2">立定跳远仿真教学与训练系统</p>
		<img class="user" src="~@img/icon/ui_sign_in.png" />

		<div class="login-container">
			<div class="layout-a input-box">
				<!-- <img src="~@img/home/ui_zh.png" alt /> -->
				<input class="usercount" v-model="number" placeholder="请输入账号" type="text" />
			</div>
			<div class="layout-a input-box">
				<!-- <img src="~@img/home/ui_mm.png" alt /> -->
				<input class="password" v-model="password" placeholder="请输入密码" type="password" />
			</div>
			<div>
				<p>注：初始密码为：000000</p>
				<p>若忘记密码请联系任课老师进行密码重置</p>
			</div>
			<button @click="login" class="login" type="primary">登 录</button>
			<div ref="tips" class="tips" v-if="errval">账号或密码填写错误！</div>
		</div>
	</div>
</template>

<script>
import store from "@/store";
export default {
	name: "Layout",
	data: () => ({
		number: "",
		password: "",
		errval: false,
		second: 5,
	}),
	methods: {
		// get http://127.0.0.1:8018/jump//jump/api/user/login?number=1&password=000000r
		async login() {
			const { number, password } = this;
			// const res = await this.$http.post('api/user/login', {
			// 	"account": "zhang", //账号
			// 	"password": "123456" //密码
			// });
			// console.log(res);
			// localStorage.setItem('X-Access-Token', res.result.token);

			let user = localStorage.getItem('X-Access-Token');
			if (user) {
				this.$router.push('/Layout/Home');
			} else {
				setTimeout(() => {
					this.errval = true;
				}, 1000);

				var timer = setInterval(() => {
					this.second -= 1;
					if (this.second == 0) {
						// this.backstart = false;
						clearInterval(timer);
						this.errval = false;
						this.second = 5;
					}
				}, 1000);

				await this.$store.dispatch('login', { number, password });
			}
			// 追加判断
			let user2 = localStorage.getItem('X-Access-Token');
			if (user2) {
				this.errval = false;
				this.$router.push('/Layout/Home');
			}

			// await this.$store.dispatch('user/getInfo');// 获取并更新用户信息

		}
	},
};
</script>

<style lang="less" scoped>
.app-wrapper {
	position: relative;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	background-image: url(~@img/background/bg.png);
	background-size: 100% 100%;
	font-family: Microsoft YaHei;

	// padding-top: 150px;
	>p {
		margin: 0;
		font-weight: bold;
		line-height: 120px;
		color: #ffffff;
		text-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
	}

	>p.title1 {
		font-size: 100px;
		letter-spacing: 10px;
		margin-top: 80px;
	}

	>p.title2 {
		font-size: 65px;
		letter-spacing: 10px;
		margin-bottom: 20px;
	}

	img.user {
		width: 120px;
		height: 120px;
	}

	.login-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		margin: 20px;
		padding: 23px;
		width: 484px;
		height: 390px;
		border-radius: 4px;
		overflow: hidden;
		position: relative;

		.input-box {
			input {
				all: unset;
				width: 360px;
				height: 45px;
				background: #ffffff;
				border: 1px solid #d9d9d9;
				opacity: 1;
				border-radius: 2px;
				padding: 0 10px;
				padding-left: 45px;
				box-sizing: border-box;

				&::placeholder {
					width: 70px;
					height: 20px;
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: 500;
					// line-height: 0px;
					padding: 0 20px;
					color: #abb6c4;
					opacity: 1;
				}
			}

			input.usercount {
				background-image: url(~@img/icon/ui_number.png);
				background-repeat: no-repeat;
				background-size: 45px 45px;
			}

			input.password {
				background-image: url(~@img/icon/ui_password.png);
				background-repeat: no-repeat;
				background-size: 45px 45px;
			}

			input::-webkit-input-placeholder {
				padding-left: 0px;
			}
		}

		p {
			font-size: 19px;
			width: 360px;
			color: white;
			text-align: left;
			margin: 0;
		}

		button.login {
			all: unset;
			width: 360px;
			height: 65px;
			background: linear-gradient(to right, #FEC937, #FF9900);
			opacity: 1;
			border-radius: 4px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: white;
			font-size: 24px;
			text-align: center;
			text-shadow: 0px 1px 2px rgba(129, 35, 0, 0.3);
			margin-bottom: 40px;
		}

		.tips {
			width: 200px;
			height: 40px;
			background-color: #FACEAE;
			text-align: center;
			color: #FC6858;
			line-height: 40px;
			font-size: 20px;
			border-radius: 5px;
			position: absolute;
			bottom: 0px;
		}
	}
}
</style>
